import {get} from 'lodash'
export const getMedicinesFromExcelData = (data) => {
  const medicineArray = []
  for(let i = 1; i < data.length; i++) {
    const item = data[i]
    if(!item.name && !item.vnr && !item.colour && !item.markings ) {
      break
    }
    const medicine = {
      activeIncr: item.activeIncr,
      name: item.name,
      intensity: item.intensity,
      pharmForm: item.pharmForm,
      atc: item.atc,
      vnr: item.vnr,
      salesPermit: item.salesPermit,
      storCond: item.storCond,
      dimensions: item.dimensions,
      colour: item.colour,
      breakline: item.breakline,
      markings: item.markings,
      leaflet: item.leaflet,
      note: item.imageUrl,
      imageUrl: item.imageUrl,
    }
    medicineArray.push(medicine)
  }
  return medicineArray
}

const cleanMedicineData = (data) => {
  if(typeof data === 'object') {
    return get(data, '_')
  }
  return data
}

const getMedicineDetails = (medicine) => {
  const items = []

  const data = get(medicine, 'content[0].html[0].body[0].div[0]')
  const title = get(medicine, 'title[0]')
  const activeIncr = get(data, 'p[0].span[0].p[0]')
  const purpose = get(data, 'p[1].span[0].p[0]')
  const dosage = get(data, 'p[2].span[0].p[0]')
  const useMethod = get(data, 'p[3].span[0].p[0]')
  const effect = get(data, 'p[4].span[0].p[0]')
  const adverseReaction = get(data, 'p[5].span[0].p[0]')
  const pregnancy = get(data, 'p[6].span[0].p[0]')
  const stowage = get(data, 'p[7].span[0].p[0]')
  const appearance = get(data, 'p[8].span[0].p[0]')

  const vnrs = get(medicine, 'vnrnumbers[0].vnr')

  if(vnrs && Array.isArray(vnrs)) {
    for(const vnr of vnrs) {
      if(vnr) {
        const item = {
          vnr: vnr,
          title: title ? cleanMedicineData(title) : '',
          activeIncr: activeIncr ? cleanMedicineData(activeIncr) : '',
          purpose: purpose ? cleanMedicineData(purpose) : '',
          dosage: dosage ? cleanMedicineData(dosage) : '',
          useMethod: useMethod ? cleanMedicineData(useMethod) : '',
          effect: effect ? cleanMedicineData(effect) : '',
          adverseReaction: adverseReaction ? cleanMedicineData(adverseReaction) : '',
          pregnancy: pregnancy ? cleanMedicineData(pregnancy) : '',
          stowage: stowage ? cleanMedicineData(stowage) : '',
          appearance: appearance ? cleanMedicineData(appearance) : '',
        }
        items.push(item)
      }
    }
  }
  return items
}
const getMedicineDetailForMedicine = (medicine) => {
  let items = []
  const medicines = get(medicine, 'medicine')
  if(medicines && Array.isArray(medicines)) {
    for(const medicine of medicines) {
      const newItems = getMedicineDetails(medicine)
      items = [...items, ...newItems]
    }
  }
  return items
}

export const getMedicineInfoDetailsFromJson = (json) => {
  let items = []
  const groups = get(json, 'medicineguide.group')
  for(const group of groups) {
    const subgroups = get(group, 'group')
    if(subgroups) {
      for(const subgroup of subgroups) {
        const medicines = get(subgroup, 'medicines')
        if(medicines && Array.isArray(medicines)) {
          for(const medicine of medicines) {
            const newItems = getMedicineDetailForMedicine(medicine)
            items = [...items, ...newItems]
          }
        }
      }
    } else {
      const medicines = get(group, 'medicines')
      if(medicines && Array.isArray(medicines)) {
        for(const medicine of medicines) {
          const newItems = getMedicineDetailForMedicine(medicine)
          items = [...items, ...newItems]
        }
      }
    }
  }
  return items
}



// WEBPACK FOOTER //
// ./src/admin/helpers.js